"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _stationStatus = require("../../hooks/queries/stationStatus");
var _mapState = require("../../hooks/mapState");
var _reactBootstrap = require("react-bootstrap");
var _moment = require("moment");
var _dateFns = require("date-fns");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _helpers = require("../../lib/helpers");
var _rcTooltip = _interopRequireDefault(require("rc-tooltip"));
var _sortBy = _interopRequireDefault(require("lodash/sortBy"));
var _layers = require("../../hooks/queries/layers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var StationDrawer = function StationDrawer(props) {
  var _stationsData$feature;
  var token = props.token;
  var _useMapState = (0, _mapState.useMapState)(),
    mapState = _useMapState.mapState,
    unselect = _useMapState.unselect;
  var selected = mapState.selected;
  var _getStopsLayer = (0, _layers.getStopsLayer)(mapState === null || mapState === void 0 ? void 0 : mapState.auth.mapLayerToken),
    stationsData = _getStopsLayer.data;
  var thisStation = stationsData === null || stationsData === void 0 ? void 0 : (_stationsData$feature = stationsData.features) === null || _stationsData$feature === void 0 ? void 0 : _stationsData$feature.find(function (oneStation) {
    return oneStation.id === selected.id;
  });
  var _useStationStatus = (0, _stationStatus.useStationStatus)(thisStation === null || thisStation === void 0 ? void 0 : thisStation.id, token),
    isLoadingStationStatus = _useStationStatus.isLoading,
    stationStatus = _useStationStatus.data;
  if (isLoadingStationStatus) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "standalone-active-train-drawer"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "panel-header dk-blue"
    }, /*#__PURE__*/_react["default"].createElement("h2", null, thisStation && "".concat(thisStation.properties.stop_name, " station")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "icons"
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _freeSolidSvgIcons.faXmark,
      size: "lg",
      onClick: function onClick() {
        unselect();
      }
    }))), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
      className: "train-drawer-row m-0"
    }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Col, {
      sm: 12,
      className: "train-drawer-column"
    }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
      className: "justify-content-center align-items-center spinner-row"
    }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Spinner, {
      className: "loading-spinner"
    })))));
  }
  if (!isLoadingStationStatus && !stationStatus) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "standalone-active-train-drawer"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "panel-header dk-blue"
    }, /*#__PURE__*/_react["default"].createElement("h2", null, thisStation && "".concat(thisStation.properties.stop_name, " station")), /*#__PURE__*/_react["default"].createElement("div", {
      className: "icons"
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _freeSolidSvgIcons.faXmark,
      size: "lg",
      onClick: function onClick() {
        unselect();
      }
    }))), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
      className: "train-drawer-row m-0"
    }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Col, {
      sm: 12,
      className: "train-drawer-column"
    }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
      className: "justify-content-center align-items-center spinner-row"
    }, /*#__PURE__*/_react["default"].createElement("p", null, "An error occured fetching the station departure board.")))));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "standalone-active-train-drawer"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "panel-header dk-blue"
  }, /*#__PURE__*/_react["default"].createElement("h2", null, thisStation && "".concat(thisStation.properties.stop_name, " station")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "icons"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faXmark,
    size: "lg",
    onClick: function onClick() {
      unselect();
    }
  }))), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
    className: "train-drawer-row m-0"
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Col, {
    sm: 12,
    className: "train-drawer-column"
  }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
    className: "mb-3 mt-3 ml-1"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    className: "clock-icon mr-2",
    icon: _freeSolidSvgIcons.faClock,
    size: "2x"
  }), /*#__PURE__*/_react["default"].createElement("h4", null, "Departure Board")), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Table, {
    className: "train-drawer-table"
  }, /*#__PURE__*/_react["default"].createElement("thead", {
    style: {
      position: 'sticky',
      top: 0,
      background: '#D0D8DF'
    }
  }, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
    className: "table-header"
  }, "Train"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "table-header"
  }, "Destination"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "table-header"
  }, "Sch Time"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "table-header"
  }, "Est Time"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "table-header"
  }, "Track"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "table-header"
  }, "Status"))), /*#__PURE__*/_react["default"].createElement("tbody", null, !!(stationStatus !== null && stationStatus !== void 0 && stationStatus.length) && stationStatus.map(function (train, index) {
    var rowClassName = index % 2 ? 'odd-train-row' : '';
    return /*#__PURE__*/_react["default"].createElement("tr", {
      className: rowClassName
    }, /*#__PURE__*/_react["default"].createElement("th", null, train.trip_name), /*#__PURE__*/_react["default"].createElement("th", null, train.destination_label), /*#__PURE__*/_react["default"].createElement("th", null, train.scheduled_arrival), /*#__PURE__*/_react["default"].createElement("th", null, train.estimatedarrival), /*#__PURE__*/_react["default"].createElement("th", null, train.track), /*#__PURE__*/_react["default"].createElement("th", null, "Status?"));
  }))))));
};
var _default = StationDrawer;
exports["default"] = _default;